import React, { RefObject, useEffect, useRef, useState } from 'react'
import { ResizeObserver } from '@juggle/resize-observer'
import { getTextWidth } from 'lib/get-text-width'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { TODAY_NEWS } from './constants/module-id'

const default_icon = require('static/today-news-default.png')
const video_orange_icon = require('static/video-red.svg')
const video_red_icon = require('static/video-hot.svg')
const video_black_icon = require('static/video-gray.svg')
export interface MisData {
  gid: string
  gid_str: string
  title: string
  url: string
  hot: number
  is_video: boolean
}

interface IProps {
  todayNews: MisData[]
  bannerRef?: RefObject<HTMLDivElement>
}

const _sliceNews = (
  news: MisData[],
  maxWidth: number,
  font = '16px PingFang SC',
  maxNum = 5,
  splitterWidth = 1,
  videoIconWidth = 20,
  margin = 12
) => {
  const cur: {
    value: number
    indices: number[]
  } = {
    value: 0,
    indices: [],
  }
  for (let i = 0; i < news.length; i++) {
    const width = getTextWidth(news[i].title, font)
    if (i === 0) {
      cur.value += width + (news[i].is_video ? videoIconWidth : 0)
      cur.indices.push(i)
      continue
    }
    if (
      cur.value +
        width +
        splitterWidth +
        margin * 2 +
        (news[i].is_video ? videoIconWidth : 0) <=
      maxWidth
    ) {
      cur.value +=
        width +
        splitterWidth +
        margin * 2 +
        (news[i].is_video ? videoIconWidth : 0)
      cur.indices.push(i)
    }
    if (cur.indices.length === maxNum) {
      // TODO:
      break
    }
  }

  const result = []
  for (const index of cur.indices.reverse()) {
    result.unshift(...news.splice(index, 1))
  }

  return result
}

const groupByWidth = (news: MisData[], max: number) => {
  const result = []

  const firstLine = _sliceNews(news, max, '18px PingFang SC')
  result.push(firstLine)
  while (news.length > 0) {
    const row = _sliceNews(news, max)
    result.push(row)
  }
  return result
}

export default function TodayNews({ todayNews }: IProps) {
  const [handledNews, setHandledNews] = useState<MisData[][]>([])
  const boxRef = useRef<HTMLDivElement>(null)
  const [show, setShow] = useState(false)
  const [marginTop, setMarginTop] = useState(8)
  const ref = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    // @ts-ignore
    if (!todayNews?.length) {
      return
    }
    const resizeObserver = new ResizeObserver(
      // @ts-ignore
      (entries: ResizeObserverEntry[]) => {
        window.requestAnimationFrame(() => {
          for (const entry of entries) {
            const { width } = entry.contentRect
            const rows = groupByWidth([...todayNews], width) || []
            setHandledNews(rows)
            const height = ref.current?.clientHeight || 0
            const rowQuantity =
              Math.floor((height - 24) / 32) >= rows.length - 1
                ? rows.length - 1
                : Math.floor((height - 24) / 32)
            setMarginTop((height - 24) / rowQuantity - 24)
            setShow(true)
          }
        })
      }
    )
    if (boxRef.current) {
      resizeObserver.observe(boxRef.current)
    }

    return () => {
      resizeObserver.disconnect()
    }
  }, [todayNews])

  return (
    <div
      className={`tw-col-span-20 xl:tw-col-span-18 2xl:tw-col-span-16 tw-bg-default-img tw-bg-center tw-bg-no-repeat tw-h-0 tw-relative tw-pb-today-news`}
      style={{
        backgroundImage: `url('${show ? '' : default_icon}')`,
      }}
      ref={ref}
    >
      <div
        className={` tw-absolute tw-left-0 tw-top-0
          tw-h-full tw-w-full tw-overflow-hidden ${
    show ? 'tw-visible' : 'tw-invisible'
    }
        `}
        ref={boxRef}
      >
        <div
          className={`row tw-text-16 tw-leading-24 tw-text-common-black tw-font-semibold tw-flex tw-items-center`}
        >
          {handledNews?.[0]?.map((item: MisData, index) => (
            <a
              className={`${
                item?.hot ? 'tw-text-common-red' : ''
              } hover:tw-text-common-orange tw-mr-13 tw-ml-12 tw-relative tw-inline-flex tw-items-center tw-flex-shrink-0 tw-flex-grow-0`}
              target={'_blank'}
              href={`/article/${item?.gid_str}`}
              onClick={() => {
                sendTeaCommEvent('clk_event', {
                  group_id: item?.gid_str,
                  event_id: 'group_module_item',
                  module_id: TODAY_NEWS,
                  rank: index,
                })
              }}
              key={item?.gid_str}
            >
              {item?.is_video && (
                <img
                  src={item?.hot ? video_red_icon : video_black_icon}
                  className={`video-icon tw-object-cover tw-object-center tw-h-17 tw-w-17 tw-mr-3`}
                />
              )}
              {item?.title}
            </a>
          ))}
        </div>

        {handledNews?.slice?.(1)?.map((row, index) => (
          <div
            className={`row tw-text-16 tw-leading-24 tw-text-common-black tw-flex tw-items-center`}
            style={{
              marginTop: `${marginTop}px`,
            }}
            key={index}
          >
            {row?.map((item: MisData, index: number) => (
              <a
                className={`${
                  item?.hot ? 'tw-text-common-red' : ''
                } hover:tw-text-common-orange tw-mr-13 tw-ml-12 tw-relative tw-inline-flex tw-items-center tw-flex-shrink-0 tw-flex-grow-0`}
                target={'_blank'}
                href={`/article/${item?.gid_str}`}
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    group_id: item?.gid_str,
                    event_id: 'group_module_item',
                    module_id: TODAY_NEWS,
                    rank: index,
                  })
                }}
                key={item?.gid_str}
              >
                {item?.is_video && (
                  <img
                    src={item?.hot ? video_red_icon : video_black_icon}
                    className={`video-icon tw-object-cover tw-object-center tw-h-17 tw-w-17 tw-mr-3`}
                  />
                )}
                {item?.title}
              </a>
            ))}
          </div>
        ))}
      </div>
      <style jsx>
        {`
          .row a:first-child {
            margin-left: 0;
          }
          .row a:not(:last-child)::after {
            content: '';
            position: absolute;
            right: -13px;
            width: 1px;
            height: 20px;
            background-color: #979aa8;
          }
          .row a:last-child {
            margin-right: 0;
          }
          .row a:hover .video-icon {
            content: url(${video_orange_icon});
          }
        `}
      </style>
    </div>
  )
}
